(function(){
  var root=document.getElementById('ybc'); if(!root) return;
  var of=window.fetch;
  var body=document.getElementById('ybc-body'), foot=document.getElementById('ybc-foot');
  var cur=(window.Shopify&&Shopify.currency&&Shopify.currency.active)||'USD';
  function money(c){ try{ return new Intl.NumberFormat(undefined,{style:'currency',currency:cur}).format(c/100); }catch(e){ return '$'+(c/100).toFixed(2); } }
  function esc(s){ return String(s==null?'':s).replace(/[&<>"]/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c];}); }
  function img(u){ if(!u) return ''; return u+(u.indexOf('?')<0?'?':'&')+'width=200'; }
  var busy=false;
  var GIFT='free-lace-converter-gift', GLOVES=window.YBGloves||[];
  function fixGift(cart){
    var gifts=[], pairs=0;
    (cart.items||[]).forEach(function(it){ if(it.handle===GIFT) gifts.push(it); else if(GLOVES.indexOf(it.product_id)>-1) pairs+=it.quantity; });
    if(!gifts.length) return null;
    var up={}, need=false;
    gifts.forEach(function(g,k){ var q=(pairs>=2 && k===0)?1:0; if(g.quantity!==q){ up[g.key]=q; need=true; } });
    if(!need) return null;
    return of.call(window,'/cart/update.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({updates:up})}).then(function(r){return r.json();});
  }
  function render(cart){
    var fx=fixGift(cart); if(fx){ fx.then(render).catch(function(){}); return; }
    var n=cart.item_count||0;
    document.getElementById('ybc-count').textContent=n?'('+n+')':'';
    document.querySelectorAll('.cart-bubble__text-count,[data-cart-count]').forEach(function(el){ el.textContent=n; });
    if(!n){
      body.innerHTML='<div class="ybc-empty"><div style="font-size:17px;font-weight:700;color:#0b0f14">Your cart is empty</div><a href="/collections/z-guard">Shop Z-GUARD</a></div>';
      foot.classList.add('is-empty'); return;
    }
    foot.classList.remove('is-empty');
    var po=cart.items.some(function(it){ return it.properties && it.properties['Pre-order']; });
    var h=po?'<div class="ybc-po"><b>Pre-order</b> · Z-GUARD ships October 27.</div>':'';
    cart.items.forEach(function(it,i){
      var props=''; if(it.properties){ for(var k in it.properties){ if(k.charAt(0)!=='_'&&it.properties[k]&&k!=='Pre-order') props+=' · '+esc(it.properties[k]); } }
      var title=it.product_title, v=(it.variant_title&&it.variant_title!=='Default Title')?it.variant_title:'';
      var was=it.original_line_price, now=it.final_line_price;
      var isGift=it.handle===GIFT;
      h+='<div class="ybc-line"><a class="ybc-img" href="'+esc(it.url)+'">'+(it.image?'<img src="'+esc(img(it.image))+'" alt="">':'')+'</a>'
        +'<div class="ybc-info"><a class="ybc-name" href="'+esc(it.url)+'">'+esc(title)+'</a>'
        +(v||props?'<div class="ybc-var">'+esc(v)+props+'</div>':'')
        +'<div class="ybc-bot">'+(isGift?'<div></div>':'<div class="ybc-qty"><button type="button" data-q="'+(i+1)+'" data-d="-1" aria-label="Less">−</button><span>'+it.quantity+'</span><button type="button" data-q="'+(i+1)+'" data-d="1" aria-label="More">+</button></div>')
        +'<div class="ybc-price">'+(isGift&&now===0?'<s>'+money(was)+'</s><span style="color:#1a8f4c">FREE</span>':(now<was?'<s>'+money(was)+'</s>':'')+money(now))+'</div></div>'
        +'<button type="button" class="ybc-rm" data-rm="'+(i+1)+'">Remove</button></div></div>';
    });
    body.innerHTML=h;
    var saved=(cart.original_total_price||0)-(cart.total_price||0);
    var sv=document.getElementById('ybc-save'); sv.hidden=saved<=0; document.getElementById('ybc-save-amt').textContent='−'+money(saved);
    document.getElementById('ybc-total').textContent=money(cart.total_price);
    document.getElementById('ybc-checkout').textContent='Checkout · '+money(cart.total_price);
  }
  function load(){ return fetch('/cart.js',{headers:{Accept:'application/json'}}).then(function(r){return r.json();}).then(function(c){ render(c); return c; }); }
  function change(line,q){
    if(busy) return; busy=true; body.style.opacity='.55';
    fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({line:line,quantity:q})})
      .then(function(r){return r.json();}).then(render).catch(load).then(function(){ busy=false; body.style.opacity=''; });
  }
  function open(){ load(); root.classList.add('is-open'); root.setAttribute('aria-hidden','false'); document.documentElement.classList.add('ybc-lock'); }
  function close(){ root.classList.remove('is-open'); root.setAttribute('aria-hidden','true'); document.documentElement.classList.remove('ybc-lock'); }
  window.YBCart={open:open,close:close,refresh:load};
  root.addEventListener('click',function(e){
    if(e.target.closest('[data-ybc-close]')){ close(); return; }
    var b=e.target.closest('[data-q]'); if(b){ var ln=+b.dataset.q, q=+b.parentNode.querySelector('span').textContent+(+b.dataset.d); change(ln,Math.max(0,q)); return; }
    var r=e.target.closest('[data-rm]'); if(r){ change(+r.dataset.rm,0); }
  });
  document.addEventListener('keydown',function(e){ if(e.key==='Escape') close(); });
  // header cart icon / any cart link opens this drawer
  document.addEventListener('click',function(e){
    var t=e.target.closest('[data-testid="cart-drawer-trigger"], a[href="/cart"], a[href$="/cart"], .action__cart');
    if(t && !root.contains(t)){ e.preventDefault(); e.stopImmediatePropagation(); open(); }
  },true);
  // open after any add-to-cart (buybox, GemPages, quick add)
  window.fetch=function(u,o){
    var p=of.apply(this,arguments), url=(typeof u==='string')?u:(u&&u.url)||'';
    if(/\/cart\/add/.test(url)) p.then(function(r){ if(r.ok) setTimeout(open,60); }).catch(function(){});
    return p;
  };
  var xo=XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open=function(m,u){ if(/\/cart\/add/.test(String(u))){ this.addEventListener('load',function(){ if(this.status<400) setTimeout(open,60); }); } return xo.apply(this,arguments); };
  // native drawer: never show it
  document.addEventListener('dialog:open',function(e){ var d=e.target&&e.target.closest&&e.target.closest('cart-drawer-component'); if(d){ try{d.close&&d.close();}catch(x){} open(); } },true);
  if(location.hash==='#cart') open();
})();
